import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import {
  breakpoints,
  colors,
  convertPxToRem,
  paragraphs
} from '@proprioo/salatim';

export const THUMBNAIL_RATIO = 0.75;
export const THUMBNAIL_MAX_WIDTH = 580;

export const Inner = styled.div`
  position: relative;
  z-index: 0;

  padding-bottom: ${100 * THUMBNAIL_RATIO}%;

  & img {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  ::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${colors.dark.base};
    opacity: 0;
    transition: opacity 150ms ease;
  }
`;

const Layout = styled.div<{
  hasError: boolean;
  isDraggable?: boolean;
  isUploading?: boolean;
}>`
  position: relative;
  z-index: 0;
  margin-bottom: ${convertPxToRem(8)};

  ${({ isDraggable }) =>
    isDraggable &&
    css`
      cursor: grab;
    `}

  ${({ hasError, isUploading }) =>
    !hasError &&
    !isUploading &&
    css`
      :hover {
        ${Inner} ::after {
          opacity: 0.5;
        }
      }
    `}
`;

export const ShowcasedLayout = styled(Layout)`
  ${Inner} {
    padding-bottom: calc(75%);
  }
`;

export const ThumnailLayout = styled(Layout)`
  position: relative;
  z-index: 0;
  width: calc(50% - ${convertPxToRem(8)});
  float: left;

  margin-right: ${convertPxToRem(8)};

  @media (min-width: ${breakpoints.small}px) {
    width: calc(100% / 3 - ${convertPxToRem(8)});
  }
`;

export const DropZone = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: ${convertPxToRem(2)} dashed ${colors.dark.base80};
  background-color: ${colors.dark.base40};
  opacity: 0.8;
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${rgba(colors.dark.base, 0.8)};
`;

export const FailedContainer = styled(OverlayContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${convertPxToRem(24)};
  ${paragraphs.body2};
  text-align: center;
  color: white;
`;
